<template>
  <!-- Main Content -->
  <v-card class="mx-auto" height="100%" width="100%">
    <!-- Left Navigation -->
    <left-navigation
      ref="left-navigation"
      v-if="$vuetify.breakpoint.mdAndUp || navMenuOpen"
    ></left-navigation>

    <!-- Top App Bar -->
    <top-navigation ref="top-navigation"></top-navigation>

    <!-- Contents -->
    <v-main>
      <v-container class="fill-height pa-0" fluid>
        <v-row no-gutters class="layout-cols-row">
          <!-- Left rail -->
          <v-col
            md="3"
            class="layout-cols layout-nav"
            v-if="$vuetify.breakpoint.mdAndUp || navMenuOpen"
          >
            <text-left-navigation
              ref="text-left-navigation"
            ></text-left-navigation>
          </v-col>
          <!-- Center rail -->
          <v-col
            cols="12"
            md="9"
            class="layout-cols"
            v-if="$vuetify.breakpoint.mdAndUp || !navMenuOpen"
          >
            <text-center-rail ref="text-center-rail"></text-center-rail>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-card>
</template>

<script>
const TopNavigation = () =>
  import(
    /* webpackChunkName: "components-global-TopNavigation" */ `../components/global/TopNavigation.vue`
  );
const LeftNavigation = () =>
  import(
    /* webpackChunkName: "components-global-LeftNavigation" */ `../components/global/LeftNavigation.vue`
  );
// const HistoryCenterRail = () =>
//   import(
//     /* webpackChunkName: "components-customers-HistoryCenterRail" */ `../components/customers/HistoryCenterRail.vue`
//   );
const TextLeftNavigation = () =>
  import(
    /* webpackChunkName: "components-messages-TextLeftNavigation" */ `../components/messages/TextLeftNavigation.vue`
  );
const TextCenterRail = () =>
  import(
    /* webpackChunkName: "components-messages-TextCenterRail" */ `../components/messages/TextCenterRail.vue`
  );
export default {
  name: "MessagesView",
  components: {
    TopNavigation,
    LeftNavigation,
    TextLeftNavigation,
    TextCenterRail
  },
  data: function() {
    return {
      settingsNavSelected: "text-uniq-conv"
    };
  },
  computed: {
    navMenuOpen() {
      return this.$root.$children[0].navMenuOpen;
    }
  }
};
</script>
